import {
  SearchState,
  UPDATE_SEARCH_KEYWORD,
  UPDATE_SEARCH_STATUS,
  UpdateSearchActions
} from "../types";

const initialState: SearchState = {
  keyword: undefined,
  status: undefined
};

export default function(
  state = initialState,
  action: UpdateSearchActions
): SearchState {
  switch (action.type) {
    case UPDATE_SEARCH_KEYWORD:
      return {
        ...state,
        keyword: action.keyword
      };
    case UPDATE_SEARCH_STATUS:
      return {
        ...state,
        status: action.status
      };
    default:
      return state;
  }
}
